<template>
  <div class="home pure-g">
    
    <MainMenu class="pure-u-1-6"/>
    
    <div class="pure-u-5-6">
      
      <div class="menuBarBox">
        <div id="menuBar" class="pure-menu pure-menu-horizontal menuBar">
          <li id="menuNewModule" class="pure-menu-item"><router-link class="pure-menu-link" to="/modules/new" >+ Neues Modul</router-link></li>
        </div>
      </div>

      <div class="formBox">
        <form class="pure-form pure-form-stacked">
          <fieldset>
            <legend>Module</legend>
            <!-- <input type="text" class="pure-input-rounded searchField" placeholder="Suchen"> -->
          </fieldset>
        </form>
      </div>
      
      <div class="tableBox">
        <div class="pure-menu pure-menu-horizontal tableNav">
          <li id="tableNavFirst" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.firstPage.href)">&lt;&lt;</a></li>
          <li id="tableNavPrev" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.prevPage.href)">&lt;</a></li>
          <li class="pure-menu-item">Seite {{ data.page + 1 }} von {{ data.pages }} &frasl; Module: {{ data.total }}</li>
          <li id="tableNavNext" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.nextPage.href)">&gt;</a></li>
          <li id="tableNavLast" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.lastPage.href)">&gt;&gt;</a></li>
        </div>
        <table class="pure-table table">
          <thead>
              <tr> 
                  <th id="colName">Name</th>
                  <th id="colType">Typ</th>
                  <th class="colAction"></th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="module in  data.data " :key="module.name">
                  <td>{{ module.name }}</td>
                  <td>{{ module.type }}</td>
                  <td>
                    <a v-on:click="editModule(module)"><pencil-icon fillColor="#444444"/></a>
                    <a v-on:click="deleteModule(module)"><delete-icon fillColor="#ff4d4d"/></a>
                  </td>
              </tr>
          </tbody>
        </table>
        
      </div>

    </div>  
  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue"
import axios from "axios"
import router from "@/router.js"
import { getJwt } from "@/utils/auth.js"
import PencilIcon from "vue-material-design-icons/pencil.vue"
import DeleteIcon from "vue-material-design-icons/delete.vue"
import { getApiUrl } from '@/utils/api.js'


export default {
  name: "moduleView",
  data: function() {
    return {
      data: { data: [] }
    };
  },
  components: {
    MainMenu,
    PencilIcon,
    DeleteIcon
  },
  mounted: function() {
    this.loadData(getApiUrl() + "/v0/modules?size=10&page=0");
  },
  methods: {
    loadData: function(url) {
      axios({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getJwt()
        }
      }).then(
        result => {
          this.data = result.data;
        },
        error => {
          console.error(error.response.data.status)
        }
      )
    },

    editModule: function(module) {
      router.push({
        name: "editModuleView",
        params: {
          url: module._links.self.href
        }
      });
    },

    deleteModule: function(module) {
      this.$modal.show("dialog", {
        title: " ",
        text:
          'Wollen Sie das Modul "' + module.name + '" wirklich löschen?',
        buttons: [
          {
            title: ""
          },
          {
            title: "Abbrechen"
          },
          {
            title: "Ok",
            default: true,
            handler: () => {
              this.restDelete(module)
              this.$modal.hide("dialog")
            }
          }
        ]
      })
    },

    restDelete: function(module) {
      
      axios({
        method: "DELETE",
        url: module._links.self.href,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getJwt()
        }
      }).then(
        result => {
          this.loadData(this.data._links.self.href);
        },
        error => {
          console.error(error.response.data.status);
        }
      );
    }
  }
};
</script>

<style>
</style>
